const pt = String(localStorage.getItem("pt"));

const DocMenuConfig: object = [
  {
    heading: "mainmenu",
    pages: [
      {
        heading: "dashboard",
        route: "/dashboardbibo",
        svgIcon: "media/icons/duotone/Home/Home.svg",
        fontIcon: "bi-app-indicator"
      },
      {
        heading: "BIBO Commissions",
        route: "/bibo",
        svgIcon: "media/icons/duotone/Devices/Phone.svg",
        fontIcon: "bi-layers"
      },
      {
        heading: "transactions",
        route: "/transactions",
        svgIcon: "media/icons/duotone/Files/Selected-file.svg",
        fontIcon: "bi-layers"
      },
      {
        heading: "encashment",
        route: "/encashment",
        svgIcon: "media/icons/duotone/Shopping/Money.svg",
        fontIcon: "bi-layers"
      },
      {
        sectionTitle: "onlineshop",
        route: "/onlineshop",
        svgIcon: "media/icons/duotone/Shopping/Bag2.svg",
        fontIcon: "bi-layers",
        sub: [
          {
            heading: "shopcodes",
            route: "/onlineshop/shopcodes/",
            svgIcon: "media/icons/duotone/Shopping/Cart1.svg",
            fontIcon: "bi-archive"
          },
          {
            heading: "shoppurchases",
            route: "/onlineshop/shoppurchases/",
            svgIcon: "media/icons/duotone/Shopping/Price1.svg",
            fontIcon: "bi-archive"
          },
          {
            heading: "retailsales",
            route: "/onlineshop/retailsales/",
            svgIcon: "media/icons/duotone/Shopping/Sale2.svg",
            fontIcon: "bi-archive"
          }
        ]
      }
    ]
  },
  {
    heading: "settings",
    route: "/settings",
    pages: [
      {
        heading: "profile",
        route: "/settings/profile/",
        svgIcon: "media/icons/duotone/General/User.svg",
        fontIcon: "bi-archive"
      },
      {
        heading: "Leader's Toolkit",
        route: "/settings/team-materials/",
        svgIcon: "media/icons/duotone/Files/Folder.svg",
        fontIcon: "bi-folder"
      },
      {
        heading: "ai247",
        route: "/settings/ai247-portal/",
        svgIcon: "media/icons/duotone/Communication/Address-card.svg",
        fontIcon: "bi-building"
      },
      {
        heading: "sites",
        route: "/sites",
        svgIcon: "media/icons/duotone/Design/Sketch.svg",
        fontIcon: "bi-globe",
        condition: "sitesPreview"
      },
      {
        heading: "Log-out",
        route: "/logout",
        svgIcon: "media/icons/duotone/Navigation/Sign-out.svg",
        fontIcon: "bi-archive"
      }
    ]
  },
];


export default DocMenuConfig;
